import React from 'react';

export const StreamChat = ({ link }) => {
    if (!link) return null;

    const hostname = window.location.hostname;
    const cleanLink = link.trim();

    // --- TWITCH CHAT ---
    const twitchMatch = cleanLink.match(/twitch\.tv\/([a-zA-Z0-9_]+)/);
    if (twitchMatch && twitchMatch[1]) {
        const channel = twitchMatch[1];
        return (
            <iframe
                src={`https://www.twitch.tv/embed/${channel}/chat?parent=${hostname}&parent=localhost&darkpopout`}
                height="100%"
                width="100%"
                style={{border: 0}}
                title={`Twitch Chat - ${channel}`}
            ></iframe>
        );
    }

    // --- YOUTUBE CHAT ---
    const ytMatch = cleanLink.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|live\/|watch\?v=|watch\?.+&v=))([^#&?]*)/);
    if (ytMatch && ytMatch[1]) {
        const videoId = ytMatch[1];
        // Note: YouTube Chat DOES NOT work on localhost. It requires a real domain.
        return (
            <iframe 
                src={`https://www.youtube.com/live_chat?v=${videoId}&embed_domain=${hostname}`}
                width="100%" 
                height="100%" 
                style={{border: 0}}
                title={`YouTube Chat - ${videoId}`}
            ></iframe>
        );
    }

    return (
        <div style={{width: '100%', height: '100%', background: '#111', color: '#888', display:'flex', alignItems:'center', justifyContent:'center', fontSize: 12}}>
            Chat not available for this stream type.
        </div>
    );
};